import { Link, useLocation } from "react-router-dom";
import { Inbox, LayoutDashboard, TrendingUp } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

const WorkspaceSwitcher = () => {
  const location = useLocation();
  const isDashboard =
    location.pathname === "/dashboard" &&
    new URLSearchParams(location.search).get("home") === "dashboard";
  const isInbox =
    (location.pathname === "/dashboard" && !isDashboard) ||
    location.pathname.startsWith("/genie-hub/inbox");
  const isInsights = location.pathname.startsWith("/genie-hub/insights");

  return (
    <TooltipProvider>
      <nav
        className="fixed right-6 top-5 z-30 hidden rounded-xl bg-white p-1 shadow-sm ring-1 ring-[#E5EAF0] md:inline-flex"
        aria-label="Workspace views"
      >
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to="/dashboard"
              aria-label="Inbox"
              aria-current={isInbox ? "page" : undefined}
              className={cn(
                "flex h-9 w-9 items-center justify-center rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-genie-primary",
                isInbox
                  ? "bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] text-white shadow-sm"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
              )}
            >
              <Inbox className="h-4 w-4" aria-hidden="true" />
            </Link>
          </TooltipTrigger>
          <TooltipContent>Inbox</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to="/dashboard?home=dashboard"
              aria-label="Dashboard"
              aria-current={isDashboard ? "page" : undefined}
              className={cn(
                "flex h-9 w-9 items-center justify-center rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-genie-primary",
                isDashboard
                  ? "bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] text-white shadow-sm"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
              )}
            >
              <LayoutDashboard className="h-4 w-4" aria-hidden="true" />
            </Link>
          </TooltipTrigger>
          <TooltipContent>Dashboard</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to="/genie-hub/insights"
              aria-label="Insights"
              aria-current={isInsights ? "page" : undefined}
              className={cn(
                "flex h-9 w-9 items-center justify-center rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-genie-primary",
                isInsights
                  ? "bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] text-white shadow-sm"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
              )}
            >
              <TrendingUp className="h-4 w-4" aria-hidden="true" />
            </Link>
          </TooltipTrigger>
          <TooltipContent>Insights</TooltipContent>
        </Tooltip>
      </nav>
    </TooltipProvider>
  );
};

export default WorkspaceSwitcher;
